import { render, staticRenderFns } from "./CodeEditor.vue?vue&type=template&id=32c5bd74&scoped=true&"
import script from "./CodeEditor.vue?vue&type=script&lang=js&"
export * from "./CodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./CodeEditor.vue?vue&type=style&index=0&id=32c5bd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5bd74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c5bd74')) {
      api.createRecord('32c5bd74', component.options)
    } else {
      api.reload('32c5bd74', component.options)
    }
    module.hot.accept("./CodeEditor.vue?vue&type=template&id=32c5bd74&scoped=true&", function () {
      api.rerender('32c5bd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/CodeEditor.vue"
export default component.exports